import { writable, derived } from 'svelte/store';
import { getConfiguration } from './AppNetwork';
import type { Configuration } from './AppTypes';

export const configurationStore = writable<Configuration | null>(null);
export const configurationError = writable<string | null>(null);
export const isConfigurationLoaded = derived(configurationStore, ($config) => $config !== null);

/**
 * Re-reads the configuration for **this** caller.
 *
 * `/api/configuration` is `publicAuth` and resolves whoever is asking, so two of its fields are
 * answers about the customer rather than about the store: `suggestedCurrency` and
 * `billingCountryRequired`. Both are wrong for an anonymous read once that same person signs in —
 * and since §14 moved sign-in *inside* the purchase window, that now happens without a page load
 * to refresh them. So the sign-in path calls this.
 */
export async function reloadConfiguration(): Promise<void> {
	await loadConfiguration();
}

export async function loadConfiguration(): Promise<void> {
	try {
		const config = await getConfiguration();
		configurationStore.set(config);
		configurationError.set(null);
	} catch (error) {
		configurationError.set(error instanceof Error ? error.message : 'Failed to load configuration');
	}
}
